import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { setOpenSnackbar } from '../../store/slices/snackbarSlice';
import useVrackApi from '../../hooks/useVrackApi';

AddCompanyAdminDialog.propTypes = {
  isOpen: PropTypes.bool,
  companyId: PropTypes.string,
  closeHandler: PropTypes.func,
  updateAdmins: PropTypes.func
};

export default function AddCompanyAdminDialog({ isOpen, closeHandler, companyId, updateAdmins }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const openSnackbar = (payload) => dispatch(setOpenSnackbar(payload));
  const { fetchData: addCompanyAdminApi } = useVrackApi('post', `/companies/${companyId}/users`);

  const trimmedEmail = email.trim();
  const isAddDisabled = !trimmedEmail || loading;

  const handleUpdateEmail = (event) => {
    setEmail(event.target.value);
  };

  const resetState = () => {
    setEmail('');
    setLoading(false);
  };

  const handleClose = () => {
    if (loading) return;
    resetState();
    closeHandler();
  };

  const handleAddAdmin = async () => {
    if (isAddDisabled) return;
    setLoading(true);
    const reqBody = {
      username: trimmedEmail,
      role: 'admin'
    };
    try {
      await addCompanyAdminApi({ data: reqBody });
      openSnackbar({ message: 'Admin added to company successfully!' });
      updateAdmins();
      closeHandler();
    } catch (error) {
      openSnackbar({ message: 'Failed to add admin to company', severity: 'error' });
    }
    setLoading(false);
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Add Admin To Company</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the email address of the user you wish to add as an admin to this company.
        </DialogContentText>
        <TextField
          required
          onChange={handleUpdateEmail}
          autoFocus
          margin="dense"
          id="email"
          label="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          value={email}
          helperText="Admin role will be automatically assigned"
          disabled={loading}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleAddAdmin} disabled={isAddDisabled}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
